export default __webpack_public_path__ + "static/media/2.1ef85f3b.png";